import React, { useCallback } from 'react';
import { useTranslation, getTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import { useRouter } from 'expo-router';
import { useAuthStore } from '@/store';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';

const ToolsRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const router = useRouter();
  const hasUser = useAuthStore(state => Boolean(state.user?.id));

  const handleHistoryClick = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    router.push('/tools/history');
  }, [router]);

  // Tool history is per-user; logged-out visitors have nothing to show.
  if (!hasUser) return null;

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="clock-rotate-left"
        tooltip={t('nav.routes.tools.historyTitle') || 'Tool history'}
        label={isXS ? undefined : (t('nav.routes.tools.history') || 'History')}
        onPress={handleHistoryClick}
      />
    </NavigationBarButtonContainer>
  );
});

ToolsRouteNavigationHeaderRight.displayName = 'ToolsRouteNavigationHeaderRight';

// Read the title once via the non-hook helper so static screens that don't
// re-render on language change still show the correct localized string.
const title = getTranslation('nav.routes.tools.title') || 'Tools';

const ToolsRouteNavigationOptions = {
  title,
  headerTitle: title,
  headerBackVisible: false,
  headerRight: () => <ToolsRouteNavigationHeaderRight />,
};

export default ToolsRouteNavigationOptions;
